import { create } from 'zustand';
import type { StanFilterValue } from '@/components/core-components/StanFilters/types';

interface RecipientsStore {
    // Filter state
    filterValues: StanFilterValue[];
    transformedFilters: string | undefined;

    // Pagination
    currentPage: number;
    pageSize: number;

    // Actions
    setFilterValues: (values: StanFilterValue[]) => void;
    setTransformedFilters: (filters: string | undefined) => void;
    setCurrentPage: (page: number) => void;
    reset: () => void;
}

const initialState = {
    filterValues: [],
    transformedFilters: undefined,
    currentPage: 1,
    pageSize: 10,
};

export const useRecipientsStore = create<RecipientsStore>(set => ({
    ...initialState,

    setFilterValues: filterValues =>
        set({
            filterValues,
            currentPage: 1, // Reset to first page when filters change
        }),

    setTransformedFilters: transformedFilters => set({ transformedFilters }),

    setCurrentPage: currentPage => set({ currentPage }),

    reset: () => set(initialState),
}));
